<template>
  <div class="tree">
    <div class="leaf n3"></div>
    <div class="leaf n2"></div>
    <div class="leaf"></div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.tree
{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 30%;
  height: 50%;
  overflow: hidden;
  max-width: 40vh;
  max-height: 50vh;
  animation-name: wind;
  animation-iteration-count: infinite;
  animation-direction: forward;
  animation-duration: 9s;
  animation-delay: 0;
}
.tree *
{
  position: relative;
  display: block;
  background-color: #1F3764;
  padding-bottom: -5px;
  margin-bottom: -5px;
}

@keyframes wind {
  100%, 0%
  {
    transform: rotate(-10deg);
  }
  50%
  {
    transform: rotate(10deg);
  }
}
@keyframes wind2 {
  100%, 0%
  {
    transform: rotate(-5deg);
  }
  50%
  {
    transform: rotate(5deg);
  }
}

.leaf
{
  width: 100%;
  height: 34%;
  clip-path: polygon(25% 0%, 75% 0%, 100% 100%, 0% 100%); 
  transform-origin: 50% 100%;
  animation: 5s wind2 infinite;
  animation-timing-function: ease-in-out;
  animation-delay: -0.1s;
}

.leaf.n3 {
  width: 50%;
  animation-delay: -0.9s;
  transform-origin: 50% 94%;
  clip-path: polygon(50% 0%, 100% 100%, 0% 100%); 
}
.leaf.n2 {
  width: 80%;
  animation-delay: -0.5s;
  transform-origin: 50% 64%;
  clip-path: polygon(30% 0%, 70% 0%, 100% 100%, 0% 100%); 

}
</style>